module.exports = __webpack_public_path__ + "static/media/bv.7ad06b05.svg";